










































































import { isValidUsername } from "@/utils/validate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { ElForm } from "element-ui/types/form";
import { ApiClient, apiClient } from '@/api/ApiClient';
import ms from 'ms';

const validateUsername = (rule: any, value: string, callback: any) => {
  if (!isValidUsername(value)) {
    callback(new Error("请输入正确的用户名"));
  } else {
    callback();
  }
};
const validatePass = (rule: any, value: string, callback: any) => {
    callback();
};

@Component
export default class Login extends Vue {
  private loginForm = {
    username: "",
    password: ""
  };
  private loginRules = {
    username: [
      { required: true, trigger: "blur", validator: validateUsername }
    ],
    password: [{ required: true, trigger: "blur", validator: validatePass }]
  };
  private loading = false;
  private pwdType = "password";
  private redirect: string | undefined = undefined;


  protected get env() {
    if (!process.env.NODE_ENV) {
      return '[ DEBUG ]';
    }

    if (process.env.VUE_APP_ENV && process.env.VUE_APP_ENV !== 'production') {
      return `[ ${process.env.VUE_APP_ENV} ]`;
    }

    if (process.env.NODE_ENV !== 'production') {
      return `[ ${process.env.NODE_ENV} ]`;
    }

    return '';
  }

  // forgot password
  public showSuccessAlert = false;
  public alertTitle = '';
  public alertDescription = '';
  public forgotPasswordFormVisible = false;

  public forgotPassword() {
    this.forgotPasswordFormVisible = true;
  }

  public async onSendMailForgotPasswordComfirm() {
    const loading = this.$loading({});
    try {
      await apiClient.forgotPassword({
        username: this.loginForm.username,
      });
      this.forgotPasswordFormVisible = false;
      this.alertTitle = 'Success';
      this.alertDescription = `We have sent an email to user ${this.loginForm.username}, please check your mail box with link and click it`;
      this.showSuccessAlert = true;
      setTimeout(() => {
        this.showSuccessAlert = false;
      }, ms('5s'));
    } finally {
      loading.close();
    }
  }

  @Watch("$route", { immediate: true })
  private OnRouteChange(route: Route) {
    // TODO: remove the "as string" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    this.redirect = route.query && (route.query.redirect as string);
  }

  private showPwd() {
    if (this.pwdType === "password") {
      this.pwdType = "";
    } else {
      this.pwdType = "password";
    }
  }

  private async handleLogin() {
    const loginForm = this.$refs.loginForm as ElForm;
    if (!await loginForm.validate()) {
      return false;
    }

    try {
      await this.$store.dispatch('user/login', this.loginForm);
      this.$router.push({ path: this.redirect || "/" });
    } catch(e) {
      console.error(e);
      throw e;
    } finally {
      this.loading = false;
    }
  }
}
